import React, { useRef } from "react";
import PlusIcon from "../icons/plusicon";
import DeletefileIcon from "../icons/Sponser_delete";

function UploadSponser({ item, handleImage, deleteImage,isboth,iconDelete}) {
	const ref = useRef(null);
	return (<>
		<div className="sd_btn"  >
			<input
				type="file"
				// id={item._id}
				ref={ref}
				style={{ display: "none" }}
				onChange={handleImage}
				accept={isboth ? ".png, .jpg, .jpeg, .mp4" : ".png, .jpg, .jpeg"}   
			/>
			<span className="sd_sponser_btn"
				onClick={() => {
					ref.current.click();
				}}
			>
			Add Image
			</span>
		
    </div>
	{/* {(item.image === '' ) ? '' : (iconDelete || isboth) &&
            <span className="remove_file pointer"
                onClick={deleteImage}
            ><DeletefileIcon /></span>
        } */}
	</>
  );
}

export default UploadSponser;
